export const appVersion = 'v1.0.0dev_20261102';
